import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { ConfirmationService, MessageService } from 'primeng/api';
import { EnfermeraService } from 'src/app/services/enfermera.service';
import { Enfermera } from 'src/app/models/enfermera.interface';
import { AuthService } from 'src/app/services/auth.service';
import { DESCRIPCION_CANJES } from 'src/app/shared/constantes/constants';
import { CasoClinico } from 'src/app/models/caso-clinico.interface';
import { CanjeEnfermera, SolicitudCanjeEnfermera } from 'src/app/models/redimir.interface';
import { HttpErrorResponse } from '@angular/common/http';
@Component({
  selector: 'app-enfermera-canje',
  templateUrl: './enfermera-canje.component.html',
  styleUrls: ['./enfermera-canje.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class EnfermeraCanjeComponent {
  canjeEnfermeraForm!: FormGroup;
  enfermera!: Enfermera;
  selectedCasosClinicos: CasoClinico[] = [];
  casosclinicos: CasoClinico[] = [];
  casosclinicoscanjear: CasoClinico[] = [];
  canjes: string[] = [...DESCRIPCION_CANJES];
  idEnfermera: number = 0;
  fechaMaxCanjeHoy = new Date();

  totalItems: number = 10;

  get cantidad(): number {
    const saldo: number = this.selectedCasosClinicos.reduce((valor, casoclinico) => casoclinico.e_puntos + valor, 0);
    return saldo;
  }
  get cantidadSolicitar(): number {
    const saldo: number = this.selectedCasosClinicos.reduce((valor, casoclinico) => casoclinico.e_puntos + valor, 0);
    return saldo;
  }

  get casosClinicos(): CasoClinico[] {
    return this.casosclinicoscanjear;
  }

  constructor(
    private fb: FormBuilder,
    private enfermeraService: EnfermeraService,
    private authService: AuthService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService) {

    if (this.authService.getUsuario?.enfermera) {
      this.idEnfermera = this.authService.getUsuario?.enfermera?.id;
      if (this.idEnfermera) this.obtenerInformacion(this.idEnfermera);
    }
    this.canjeEnfermeraForm = this.crearFormularioCanje();

  }
  crearFormularioCanje(): FormGroup {
    return this.fb.group({
      fechaInicio: ['', Validators.required]
    })
  }
  obtenerInformacion(id: number): void {
    this.enfermeraService.getEnfermeraPreSolicitud(id).subscribe({
      next: (resp) => {
        this.solicitudCanjeInicio(resp.datos);
        console.log(resp)
      },
      error: (err) => console.log(err)
    });
  }

  onSubmit(): void {
    const fecha = new DatePipe("en-US");
    const { fechaInicio } = this.canjeEnfermeraForm.value;
    const concepto: number = 1;
    const descripcion: string = "Efectivo";
    const cantidadRedimir: number = this.selectedCasosClinicos.reduce((valor, casoclinico) => casoclinico.e_puntos + valor, 0);

    const canje: CanjeEnfermera = { status: 1, redimir: cantidadRedimir, fk_enfermera: 0, fechaInicio, concepto, descripcion };
    const idscasosclinicos: number[] = this.selectedCasosClinicos.map((item) => item.id);

    canje.fechaInicio = <string>fecha.transform(fechaInicio, 'yyyy-MM-dd')?.toString();
    canje.fk_enfermera = this.idEnfermera;

    const solicitud: SolicitudCanjeEnfermera = { canje, casosclinicos: idscasosclinicos };

    if (this.idEnfermera != 0) {
      if (this.selectedCasosClinicos.length === 0) {
        this.showError("Selecciona al menos un caso clinico para solicitar el canje");
        return;
      }

      this.confirmationService.confirm({
        message: 'No. Casos Clinicos seleccionados : ' + this.selectedCasosClinicos.length + ' y cantidad a solicitar: ' + this.cantidadSolicitar + ' puntos. ¿Deseas continuar con la solicitud de canje?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.enfermeraService.setSolicitudCanje(solicitud)
            .subscribe({
              next: (resp) => { this.showSuccess(resp.mensaje); },
              error: (err: HttpErrorResponse) => { this.showError(err.error.message) }
            })
        }
      });
    }

  }
  solicitudCanjeInicio(enfermera: Enfermera) {
    this.casosclinicos.push(...enfermera.casosclinicos);
    this.casosclinicoscanjear = this.casosclinicos; //.filter((item) => (item.productos.length > 0) && (item.documentos.length > 0) && (item.e_puntos > 0));
    this.enfermera = enfermera;
    this.totalItems = this.casosclinicoscanjear.length;
  }

  getCanje(id: number): string {
    return this.canjes[id];
  }

  showSuccess(mensaje: string): void {
    this.messageService.add({
      severity: 'success',
      summary: 'Éxito',
      detail: mensaje
    });
  }
  showError(mensaje: string): void {
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: mensaje
    });
  }
}
